import {configure} from 'vee-validate'
import {defineNuxtPlugin} from "#app"
import { es } from 'yup-locales'
import { setLocale } from 'yup'

export default defineNuxtPlugin(() => {

  configure({
    validateOnBlur: false,
    validateOnChange: false,
    validateOnInput: false,
    validateOnModelUpdate: false
  })

  setLocale(es)
})
